import script from "./category-entry.vue?vue&type=script&lang=tsx"
export * from "./category-entry.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__